export function customerJourneySummary(metadata: any) {
  const j = metadata?.partner_customer;
  if (!j) return { source_name: null, manager_name: null, journey_stage: null, fee_amount: null, payer: null, allowed_payer: null };
  return {
    source_name: j.attribution?.source_name || null,
    manager_name: j.attribution?.manager_name || null,
    journey_stage: j.mode === 'rupiqa_portal'
      ? j.customer_submitted_at ? 'submitted' : j.customer_details_saved_at ? 'documents_pending' : 'details_pending'
      : j.stage || null,
    fee_amount: typeof j.fee?.amountPaise === 'number' ? j.fee.amountPaise / 100 : null,
    payer: j.payer || null,
    allowed_payer: j.fee?.feeEnabled ? j.fee.payer : null,
  };
}
export function customerStageLabel(stage: string | null | undefined) {
  return ({
    payment_type_pending: 'Select payment type',
    payment_pending: 'Payment pending',
    lender_selection_pending: 'Select lender',
    profile_collected: 'Details saved',
    details_saved: 'Details saved',
    details_pending: 'Customer details pending',
    documents_pending: 'Customer documents pending',
    submitted: 'Submitted for review',
    portal_opened: 'Application link opened',
    link_ready: 'Link ready',
    redirect_requested: 'Lender link opened',
    disbursed: 'Disbursed',
    rejected: 'Rejected',
  } as Record<string,string>)[stage || ''] || null;
}

// A link preview/visit is telemetry, never proof of application progress.
export function customerApplicationStatus(lifecycle: unknown, metadata?: unknown): 'Pending' | 'In Progress' | 'Disbursed' | 'Rejected' {
  const state = String(lifecycle || '').toLowerCase();
  if (['disbursed', 'loan_disbursed'].includes(state)) return 'Disbursed';
  if (state === 'rejected') return 'Rejected';
  const stage = customerJourneySummary(metadata).journey_stage;
  if (['submitted', 'documents_pending'].includes(stage || '') || ['cibil_done', 'advisor_review', 'qualified', 'chatting', 'application_ready', 'in_progress'].includes(state)) return 'In Progress';
  return 'Pending';
}

export function normalizeCustomerMobileInput(value: string): string {
  const digits = value.replace(/\D/g, '');
  return digits.length === 12 && digits.startsWith('91') ? digits.slice(2) : digits;
}
